'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
var $ = require("jquery");
var App = /** @class */ (function () {
    function App() {
        var _this = this;
        $('.trigAppSelect').on('click', function (e) {
            _this.changeSelect(e);
            var url = $(e.currentTarget).attr('data-image');
            $('.bulletAppImage').css('background-image', "url(" + url + ")");
        });
    }
    App.prototype.changeSelect = function (e) {
        $('.trigAppSelect').attr('data-is-select', 'false');
        $(e.currentTarget).attr('data-is-select', 'true');
    };
    return App;
}());
exports.App = App;
exports.default = App;
